var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AnalyticsSubPage,{attrs:{"title":"Savings Analytics","icon":"piggy-bank","css-class":"analytics-savings","default-label":"Savings"}},[_c(_setup.BuildMetrics)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }